export type EmployeeRole =
  | 'OPERATIONAL'
  | 'ADMINISTRATIVE'
  | 'FINANCIAL'
  | 'MANAGEMENT'
  | 'OTHER'

export interface Employee {
  id: string
  name: string
  cpf: string
  role: EmployeeRole
  hireDate: string
  terminationDate: string | null
  baseSalary: string
  paymentDay: number
  email: string | null
  phone: string | null
  bankName: string | null
  bankAgency: string | null
  bankAccount: string | null
  bankAccountType: string | null
  pixKey: string | null
  active: boolean
  createdAt: string
  updatedAt: string
}

export interface PaginatedEmployees {
  data: Employee[]
  total: number
  page: number
  perPage: number
  totalPages: number
}

export const EMPLOYEE_ROLE_LABELS: Record<EmployeeRole, string> = {
  OPERATIONAL: 'Operacional',
  ADMINISTRATIVE: 'Administrativo',
  FINANCIAL: 'Financeiro',
  MANAGEMENT: 'Diretoria',
  OTHER: 'Outro',
}

export type PaymentMethod = 'PIX' | 'BANK_TRANSFER' | 'BANK_SLIP' | 'CASH' | 'OTHER'

export interface SalaryPayment {
  id: string
  employeeId: string
  referenceMonth: number
  referenceYear: number
  amount: string
  paymentDate: string
  method: PaymentMethod
  notes: string | null
  createdAt: string
}
